import React, { useCallback, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import {
  PRODUCT_ADD_URL,
  PRODUCT_DETAILS_URL,
  PRODUCT_IMAGE_URL,
  PRODUCT_LIVE_URL,
  PRODUCT_GALLERY_IMAGES_URL,
  PRODUCT_UPLOAD_IMAGE_URL,
  PRODUCT_ASSOCIATE_IMAGE_URL,
  PRODUCT_DELETE_IMAGE_URL
} from "../../utils/Constant";
import {
  usersList,
  categoryList,
  convertIsoToCustomFormat,
  convertIsoToLocalFormat,
} from "../../utils/Helper";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDropzone } from "react-dropzone";
import "./AddProductPage.css";
import "react-dropzone/examples/theme.css";
import CountdownTimer from "./CountdownTimer";
import axios from "axios";
import ProductLive from "../../components/productLive/ProductLive";
import ProductBidHistory from "./ProductBidHistory";
const moment = require("moment-timezone");

function ProductListPage() {
  // Image Gallery

  const [uploadedImages, setUploadedImages] = useState([]);
  const [newProductId, setNewProductId] = useState(null);
  const [loading, setLoading] = useState(false);
  // Input keys start----------------------------------------------------
  const [productName, setProductName] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [shortDescription, setShortDescription] = useState("");

  const [featuredStatus, setFeaturedStatus] = useState("false");
  const [stockAvailability, setStockAvailability] = useState("true");
  const [productCondition, setProductCondition] = useState("new");
  const [sellerId, setSellerId] = useState("65b9fc3f0d3ddcb06efc0db1");
  const [productOwner, setProductOwner] = useState("admin");

  const [buyStatus, setBuyStatus] = useState("both");
  const [openingPrice, setOpeningPrice] = useState("");
  const [lowestPrice, setLowestPrice] = useState("");
  const [bidIncrement, setBidIncrement] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [buyingPrice, setBuyingPrice] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isPremiumEnabled, setIsPremiumEnabled] = useState("false");
  const [premiumType, setPremiumType] = useState("flat");
  const [premiumAmount, setPremiumAmount] = useState("");
  const [maxPremiumAmount, setMaxPremiumAmount] = useState("");
  const [minPremiumAmount, setMinPremiumAmount] = useState("");
  const [productStatus, setProductStatus] = useState("publish");
  const [categoryId, setCategoryId] = useState("");
  const [selectCategory, setSelectCategory] = useState("");
  const [productImage, setProductImage] = useState(null);
  const [productIsLive, setProductIsLive] = useState(false);
  const [upfrontPercentage, setUpfrontPercentage] = useState("");
  // Input keys End----------------------------------------------------

  const [users, setUsers] = useState([]);
  const [category, setCategory] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [productDetails, setProductDetails] = useState({});


  //current timezone 
  function getProductTimeZone() {
    const date = new Date(); // Get the current date/time
    const options = { timeZoneName: 'short' }; // Specify to get the short name of the time zone
    const productTimeZone = Intl.DateTimeFormat(undefined, options).resolvedOptions().timeZone;
    return productTimeZone;
  }

  // Example usage
  const productTimeZone = getProductTimeZone();
  //console.log("productTimeZone",productTimeZone);


  //console.log("productDetails:::::::::::", productDetails);

  const navigate = useNavigate();
  const { productId } = useParams();

  const authToken = useSelector((state) => state.token);
  let isBidNotStarted = "";
  let isBidStarted = "";
  let isBidExpired = "";
  // Auction Status Code :
  if (productId) {
    isBidNotStarted = +new Date() < +new Date(productDetails.bidStartDate);
    isBidStarted =
      !isBidNotStarted &&
      +new Date() >= +new Date(productDetails.bidStartDate) &&
      +new Date() <= +new Date(productDetails.bidEndDate);
    isBidExpired = +new Date() > +new Date(productDetails.bidEndDate);
  }

  useEffect(() => {
    setNewProductId(productId);
    if (authToken) {
      const fetchDetails = async () => {
        try {
          setNewProductId(productId);
          if (productId) {
            showToast(true, "Data Loading. Please wait..", "info");
          }
          const response = await fetch(`${PRODUCT_DETAILS_URL}/${productId}`, {
            headers: {
              Authorization: `Bearer ${authToken.token}`,
            },
          });

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          /*** Dropzone code start */
          const responseImages = await fetch(`${PRODUCT_GALLERY_IMAGES_URL}/${productId}`,
            {
              headers: {
                Authorization: `Bearer ${authToken.token}`,
              },
            }
          );

          if (!responseImages.ok) {
            throw new Error(`HTTP error! Status: ${responseImages.status}`);
          }
          let exiestingGalleryImages = await responseImages.json();

          setUploadedImages(exiestingGalleryImages.data);
          /* Drop Zone Code End */
          const data = await response.json();
          setProductDetails(data.data);
          setProductName(data.data.productName || "");
          setProductDescription(data.data.productDescription || "");
          setShortDescription(data.data.productShortDescription || "");
          setFeaturedStatus(!data.data.isFeatured ? "false" : "true" || "");
          setStockAvailability(!data.data.inStock ? "false" : "true" || "");
          setProductCondition(data.data.productCondition || "");
          setProductOwner(data.data.sellerId.username || "");
          setSellerId(data.data.sellerId._id || "");
          setBuyStatus(data.data.sellingType || "");
          setOpeningPrice(data.data.openingPrice || "");
          setLowestPrice(data.data.lowestPriceAccept || "");
          setBidIncrement(data.data.bidIncrement || "");
          setQuantity(data.data.quantity || "");
          setBuyingPrice(data.data.buyNowPrice || "");
          //const bidSDate = new Date(data.data.bidStartDate);
          //const bStartDate = bidSDate.toISOString().slice(0, 16);
          setStartDate(data.data.bidStartDate);
          setUpfrontPercentage(data.data.upfrontPercentage || 0);


          //const bidEDate = new Date(data.data.bidEndDate);
          //const bEndDate = bidEDate.toISOString().slice(0, 16);
          setEndDate(data.data.bidEndDate);
          setIsPremiumEnabled(
            !data.data.isPremiumEnabled ? "false" : "true" || ""
          );
          setPremiumType(data.data.premiumType || "");
          setPremiumAmount(data.data.premiumAmount || "");
          setMaxPremiumAmount(data.data.maxPremiumAmount || "");
          setMinPremiumAmount(data.data.minPremiumAmount || "");
          setProductStatus(data.data.productStatus || "");
          setSelectCategory(data.data.categoryId.categoryName || "");

          setProductIsLive(data.data.isLive || "");

          setProductImage(data.data.featuredImage || "");
          setImagePreview(
            productImage ? URL.createObjectURL(productImage) : null
          );
        } catch (error) {
          //console.error("Error fetching product:", error);
        }
      };
      fetchDetails();
    } else {
      navigate("/login");
    }
  }, [productId]);

  const showToast = (loading, message, type, errors) => {
    let errorMessage = "";

    if (errors && errors.length > 0) {
      errorMessage = (
        <ul>
          {errors.map((error, index) => (
            <li key={index}>{error.msg}</li>
          ))}
        </ul>
      );
    }
    toast[type](
      <div>
        {loading} {message} {errorMessage}
      </div>,
      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000, // milliseconds
      }
    );
  };

  /****************Dropzone Start */

  const onDrop = useCallback(async (acceptedFiles) => {
    setLoading(true);
    // Assume you have a function for uploading images
    const uploadedImagesData = await uploadImages(acceptedFiles);
    // Update the state with the uploaded images
    setUploadedImages((prevImages) => [...prevImages, ...uploadedImagesData]);
    setLoading(false);
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    //accept: ['image/jpeg', 'image/png', 'image/gif'],
    multiple: true,
    onDrop,
  });
  const handleDeleteImage = async (imageId) => {
    setLoading(true);
    // imageId.preventDefault();
    // Assume you have a function for deleting an image
    await deleteImage(imageId);

    // Update the state by removing the deleted image
    setUploadedImages((prevImages) =>
      prevImages.filter((image) => image._id !== imageId)
    );
    setLoading(false);
  };
  const uploadImages = async (images) => {
    const formData = new FormData();
    images.forEach((file) => {
      formData.append("imageGallery", file);
    });

    const uploadedImagesData = await fetch(PRODUCT_UPLOAD_IMAGE_URL,
      {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${authToken.token}`,
          // Add other headers if needed
        },
      }
    ).then((response) => response.json());

    return uploadedImagesData.data;
  };
  const associateImagesWithProduct = async (prodId, images) => {
    // Implement logic to associate the uploaded images with the product
    // Example: Assuming your server has an endpoint to associate images with a product
    const imageIds = images.map((image) => image._id);
    await fetch(`${PRODUCT_ASSOCIATE_IMAGE_URL}/${prodId}`,
      {
        method: "PUT",
        body: JSON.stringify({ imageIds: imageIds }),
        headers: {
          Authorization: `Bearer ${authToken.token}`,
          "Content-Type": "application/json",
        },
      }
    );
  };
  const deleteImage = async (imageId) => {
    // Implement logic to delete the image from the server
    // Example: Assuming your server has an endpoint to delete an image
    await fetch(
      `${PRODUCT_DELETE_IMAGE_URL}/${imageId}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${authToken.token}`,
          "Content-Type": "application/json",
        },
      }
    );
  };
  /****************Dropzone End */

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setImagePreview(file ? URL.createObjectURL(file) : null);
    setProductImage(event.target.files[0]);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("productName", productName);
    formData.append("productDescription", productDescription);
    formData.append("productShortDescription", shortDescription);
    formData.append("isFeatured", featuredStatus);
    formData.append("inStock", stockAvailability);
    formData.append("productCondition", productCondition);
    formData.append("sellerId", sellerId);
    formData.append("sellingType", buyStatus);
    formData.append("openingPrice", openingPrice);
    formData.append("lowestPriceAccept", lowestPrice);
    formData.append("upfrontPercentage", upfrontPercentage);
    formData.append("bidIncrement", bidIncrement);
    formData.append("quantity", quantity);
    formData.append("buyNowPrice", buyingPrice);
    // formData.append("bidStartDate", startDate.replace("T", " ") + ":00");
    // formData.append("bidEndDate", endDate.replace("T", " ") + ":00");

    formData.append("bidStartDate", startDate);
    formData.append("bidEndDate", endDate);

    formData.append("isPremiumEnabled", isPremiumEnabled);
    formData.append("premiumType", premiumType);
    formData.append("premiumAmount", premiumAmount);
    formData.append("maxPremiumAmount", maxPremiumAmount);
    formData.append("minPremiumAmount", minPremiumAmount);
    formData.append("productStatus", productStatus);
    formData.append("categoryId", categoryId);
    formData.append("featuredImage", productImage);
    formData.append("timezone", productTimeZone);
    console.log('f',formData);
    try {
      showToast(true, "In Progress. Please wait..", "info");
      const response = await fetch(
        newProductId
          ? `${PRODUCT_DETAILS_URL}/${newProductId}`
          : PRODUCT_ADD_URL,
        {
          method: newProductId ? "PUT" : "POST",
          headers: {
            Authorization: `Bearer ${authToken.token}`,
          },
          body: formData,
        }
      );

      const data = await response.json();
      if (response.ok) {
        showToast(true, "Auction updated successfully!", "success");

        /**Dropzone  start*/
        setNewProductId(data.data._id);
        // Assume you have a function for associating images with the product
        await associateImagesWithProduct(data.data._id, uploadedImages);

        /**Dropzone end */

        setTimeout(() => {
          navigate(`/products/update/${data.data._id}`);
        }, 1000);
        ////console.log("Product updated successfully!");
      } else {
        showToast(true, "An error occurred.", "error", data.errors);
      }
    } catch (error) {
      showToast(true, "Test :  " + error.message, "error");
      console.error(error.message, error);
    }
  };

  useEffect(() => {
    const fetchLists = async () => {
      try {
        const [usersData, categoryData] = await Promise.all([
          usersList(authToken),
          categoryList(authToken),
        ]);
        setUsers(usersData);
        setCategory(categoryData);
      } catch (error) { }
    };
    if (premiumType == "flat") {
      setMaxPremiumAmount("");
      setMinPremiumAmount("");
    }

    fetchLists();
  }, [maxPremiumAmount, minPremiumAmount, premiumType]);

  const handleIsLive = async (e) => {
    e.preventDefault();
    try {
      showToast(true, "In Progress. Please wait..", "info");
      const response = await fetch(`${PRODUCT_LIVE_URL}/${newProductId}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken.token}`,
        },
      });
      const data = await response.json();
      if (response.ok) {
        showToast(true, data.msg, "success");
        setProductIsLive(true);
      } else {
        showToast(true, "An error occurred.", "error", data.errors);
      }
    } catch (error) {
      showToast(true, "Test :  " + error.message, "error");
      console.error(error.message, error);
    }
  };

  return (
    <DashboardLayout>
      <form onSubmit={handleFormSubmit}>
        <div className="row">
          <div className="col-md-9">
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">
                  <b>General Product Details</b>
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Collapse"
                  >
                    <i className="fas fa-minus" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="productName">Product Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="productName"
                    name="productName"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                    placeholder="Product Name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="productDescription">
                    Product Description
                  </label>
                  <textarea
                    className="textarea form-control"
                    placeholder="Product Description"
                    id="productDescription"
                    name="productDescription"
                    value={productDescription}
                    onChange={(e) => setProductDescription(e.target.value)}
                    rows={5}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="shortDescription">
                    Product Short Description
                  </label>
                  <textarea
                    className="textarea form-control"
                    placeholder="Product Short Description"
                    id="shortDescription"
                    name="shortDescription"
                    value={shortDescription}
                    onChange={(e) => setShortDescription(e.target.value)}
                    rows={3}
                  />
                </div>
              </div>
            </div>
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">
                  <b>Other Product Details</b>
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Collapse"
                  >
                    <i className="fas fa-minus" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-3">
                    <div className="form-group">
                      <label htmlFor="featuredStatus">Is Featured ?</label>
                      <select
                        className="form-control custom-select"
                        name="featuredStatus"
                        value={featuredStatus}
                        onChange={(e) => setFeaturedStatus(e.target.value)}
                      >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label htmlFor="stockAvailability">Stock Status</label>
                      <select
                        className="form-control custom-select"
                        name="stockAvailability"
                        value={stockAvailability}
                        onChange={(e) => setStockAvailability(e.target.value)}
                      >
                        <option value="true">In Stock</option>
                        <option value="false">Out of Stock</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-3">
                    {/* text input */}
                    <div className="form-group">
                      <label htmlFor="productCondition">
                        Product Condition
                      </label>
                      <select
                        className="form-control custom-select"
                        name="productCondition"
                        value={productCondition}
                        onChange={(e) => setProductCondition(e.target.value)}
                      >
                        <option value="new">New</option>
                        <option value="used">Used</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="form-group">
                      <label htmlFor="productOwner">Owner</label>
                      <select
                        className="form-control custom-select"
                        name="productOwner"
                        value={productOwner}
                        onChange={(e) => {
                          setProductOwner(e.target.value);
                          const userObject = users.find(
                            (user) => user.username === e.target.value
                          );
                          setSellerId(userObject._id);
                        }}
                      // onChange={(e) => setProductOwner(e.target.value)}
                      >
                        {/* Default option */}
                        <option value="">Select Product Owner</option>

                        {/* Dynamically generate options based on users list */}
                        {users.map((user) => (
                          <option key={user._id} value={user.username}>
                            {user.username}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              {/* /.card-body */}
            </div>
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">
                  <b>Product Auction Details</b>
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Collapse"
                  >
                    <i className="fas fa-minus" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-4">
                    <div className="form-group">
                      <label htmlFor="buyStatus">Selling Type</label>
                      <select
                        className="form-control custom-select"
                        name="buyStatus"
                        value={buyStatus}
                        onChange={(e) => setBuyStatus(e.target.value)}
                      >
                        <option value="none">None</option>
                        <option value="buynow">Buy it Now</option>
                        <option value="bidnow">Auction</option>
                        <option value="both">Both</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group">
                      <label htmlFor="openingPrice">Opening Price</label>
                      <input
                        type="number"
                        className="form-control"
                        id="openingPrice"
                        placeholder="Opening Price"
                        name="openingPrice"
                        value={openingPrice}
                        onChange={(e) => setOpeningPrice(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group">
                      <label htmlFor="lowestPrice">
                        Lowest Price to Accept ($)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="lowestPrice"
                        placeholder="Lowest Price to Accept ($)"
                        name="lowestPrice"
                        value={lowestPrice}
                        onChange={(e) => setLowestPrice(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group">
                      <label htmlFor="bidIncrement">Bid Increment ($)</label>
                      <input
                        type="number"
                        className="form-control"
                        id="bidIncrement"
                        placeholder="Bid Increment ($)"
                        name="bidIncrement"
                        value={bidIncrement}
                        onChange={(e) => setBidIncrement(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-4">
                    <div className="form-group">
                      <label htmlFor="quantity">Quantity</label>
                      <input
                        type="number"
                        className="form-control"
                        id="quantity"
                        placeholder="No of Quantity"
                        defaultValue={1}
                        name="quantity"
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-4">
                    <div className="form-group">
                      <label htmlFor="buyingPrice">Buy Now Price</label>
                      <input
                        type="number"
                        className="form-control"
                        id="buyingPrice"
                        placeholder="Buy Now Price"
                        name="buyingPrice"
                        value={buyingPrice}
                        onChange={(e) => setBuyingPrice(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="startDate">Start Date</label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        id="startDate"
                        placeholder="Start Date"
                        name="startDate"
                        value={convertIsoToLocalFormat(startDate)}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="endDate">Ending Date</label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        id="endDate"
                        placeholder="Ending Date"
                        name="endDate"
                        min={convertIsoToLocalFormat(startDate)}
                        value={convertIsoToLocalFormat(endDate)}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* /.card-body */}
            </div>
            <div className="card card-default  collapsed-card">
              <div className="card-header">
                <h3 className="card-title">
                  <b>Set Buyer's Premium (B.P) Details</b>
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Collapse"
                  >
                    <i className="fas fa-plus" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="isPremiumEnabled">
                        Buyer's Premium Enabled ?
                      </label>
                      <select
                        className="form-control custom-select"
                        name="isPremiumEnabled"
                        value={isPremiumEnabled}
                        onChange={(e) => setIsPremiumEnabled(e.target.value)}
                      >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="premiumType">Premium Type</label>
                      <select
                        className="form-control custom-select"
                        name="premiumType"
                        value={premiumType}
                        onChange={(e) => setPremiumType(e.target.value)}
                        disabled={isPremiumEnabled == "false"}
                      >
                        <option value="flat">Flat ($)</option>
                        <option value="percentage">Percentage (%)</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group">
                      <label htmlFor="productOwner">
                        Premium Fee Amount (in % or $)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="premiumAmount"
                        placeholder="Premium Fee Amount (in % or $)"
                        name="premiumAmount"
                        disabled={isPremiumEnabled == "false"}
                        value={premiumAmount}
                        required
                        onChange={(e) => setPremiumAmount(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group">
                      <label htmlFor="productOwner">
                        Min Premium Amount ($)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="minPremiumAmount"
                        placeholder="Min Premium Amount ($)"
                        name="minPremiumAmount"
                        disabled={
                          isPremiumEnabled == "false" || premiumType == "flat"
                        }
                        value={minPremiumAmount}
                        required
                        onChange={(e) => setMinPremiumAmount(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="form-group">
                      <label htmlFor="productOwner">
                        Max Premium Amount ($)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="maxPremiumAmount"
                        placeholder="Max Premium Amount ($)"
                        name="maxPremiumAmount"
                        required
                        disabled={
                          isPremiumEnabled == "false" || premiumType == "flat"
                        }
                        value={maxPremiumAmount}
                        onChange={(e) => setMaxPremiumAmount(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* /.card-body */}
            </div>
            <ProductBidHistory />
          </div>
          <div className="col-md-3">
            {newProductId ? (
              <div className="card card-default">
                <div className="card-body">
                  <div className="alert alert-primary" role="alert">
                    <CountdownTimer
                      startDate={productDetails.bidStartDate}
                      endDate={productDetails.bidEndDate}
                    />
                  </div>


                  <>

                    <ProductLive
                      newProductId={newProductId}
                      productDetails={productDetails}
                    />
                    <br></br>
                    <p>
                      <b>Current Status : &nbsp;</b>
                      {productIsLive ? (
                        <>
                          <i className="fas fa-solid fa-circle green-btn" /> Live
                        </>
                      ) : (
                        <>
                          <i className="fas fa-solid fa-circle red-btn" /> Not
                          Live
                        </>
                      )}
                    </p>
                  </>
                  {productDetails && Object.keys(productDetails).length > 0 && (
                    <p>

                      <b>
                        Published on: &nbsp;
                      </b>
                      {convertIsoToCustomFormat(productDetails.created_at)}
                    </p>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}

            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">
                  <b>Product Categories</b>
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Collapse"
                  >
                    <i className="fas fa-minus" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="inputStatus">Select Category</label>
                  <select
                    className="form-control custom-select"
                    name="selectCategory"
                    value={selectCategory}
                    onChange={(e) => {
                      setSelectCategory(e.target.value);
                      const categoryObject = category.find(
                        (cat) => cat.categoryName === e.target.value
                      );
                      setCategoryId(categoryObject._id);
                    }}
                  >
                    <option value="">Select Category</option>
                    {category.map((item) => (
                      <option key={item._id} value={item.categoryName}>
                        {item.categoryName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">
                  <b>Up Front Percentage (%)</b>
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Collapse"
                  >
                    <i className="fas fa-minus" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="inputStatus">Up Front Percentage (%)</label>

                  <input
                    type="number"
                    className="form-control"
                    id="upfrontPercentage"
                    placeholder="Upfront Percentage (%)"
                    name="upfrontPercentage"
                    min={1}
                    value={upfrontPercentage}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "" || Number(val) > 0) {
                        setUpfrontPercentage(val);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">
                  <b>Product Thumbnail</b>
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Collapse"
                  >
                    <i className="fas fa-minus" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="form-group">
                  <div className="input-group">
                    <div className="custom-file">
                      <input
                        type="file"
                        className="custom-file-input"
                        id="exampleInputFile"
                        onChange={handleFileChange}
                      />
                      <label
                        className="custom-file-label"
                        htmlFor="exampleInputFile"
                      >
                        Choose file
                      </label>
                    </div>
                    <div className="input-group-append">
                      <span className="input-group-text" id="">
                        Upload
                      </span>
                    </div>
                  </div>
                  {imagePreview ? (
                    <div>
                      <br></br>
                      <img
                        src={imagePreview}
                        alt="Preview"
                        style={{ width: "100%", height: "200px" }}
                      />
                    </div>
                  ) : productImage ? (
                    <div>
                      <br></br>
                      <img
                        src={`${PRODUCT_IMAGE_URL}/${productImage}`}
                        alt="Preview"
                        style={{ width: "100%", height: "200px" }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">
                  <b>Product Gallery</b>
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Collapse"
                  >
                    <i className="fas fa-minus" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div>
                  <div
                    {...getRootProps()}
                    className={`dropzone ${isDragActive ? "active" : ""}`}
                  >
                    <input {...getInputProps()} />
                    <p>Drag & drop images here, or click to select files</p>
                    {loading ? (
                      <div className="text-center">
                        <div className="text-center">
                          <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <p className="uploadIcon">
                          <i className="fas fa-upload" />
                        </p>
                      </>
                    )}
                  </div>

                  <div className="uploaded-images-container">
                    {uploadedImages.map((image) => (
                      <div key={image._id} className="uploaded-image">
                        <img
                          src={`${PRODUCT_IMAGE_URL}/${image.imageName}`}
                          alt="Uploaded"
                        />
                        <a
                          className="deleteImage"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleDeleteImage(image._id);
                          }}
                        >
                          <i className="fas fa-times delete-icon" />
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="card card-default">
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="productStatus">Product Status</label>
                  <select
                    className="form-control custom-select"
                    name="productStatus"
                    value={productStatus}
                    onChange={(e) => setProductStatus(e.target.value)}
                  >
                    <option value="publish">Publish</option>
                    <option value="draft">Draft</option>
                    <option value="pending_review">Pending Review</option>
                  </select>
                </div>
                <br />
                <a href="/products/list" className="btn btn-danger">
                  Discard
                </a>
                <input
                  type="submit"
                  value={productId ? "Update Auction" : "Create Auction"}
                  defaultValue="Publish Product"
                  className="btn btn-success float-right"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </DashboardLayout>
  );
}

export default ProductListPage;
